import { createFileRoute } from '@tanstack/react-router'
import { RunsPage } from '../../../../features/payroll/runs-page'
import { runSearchSchema } from '../../../../features/payroll/search'

export const Route = createFileRoute('/_app/payroll/runs/')({
  validateSearch: runSearchSchema,
  component: RunsPage,
})
